/* eslint-disable */
let heroElement;

// Set things up
window.addEventListener(
  'load',
  event => {
    heroElement = document.querySelector('.technologies .hero-background');

    if (heroElement) {
      createObserver();
    }
  },
  false
);

function createObserver() {
  let heroObserver;

  let options = {
    root: null,
    rootMargin: '-120px 0px 0px 0px',
    threshold: buildThresholdList(),
  };

  heroObserver = new IntersectionObserver(handleIntersect, options);
  heroObserver.observe(heroElement);
}

function buildThresholdList() {
  let thresholds = [];
  let numSteps = 50;

  for (let i = 1.0; i <= numSteps; i++) {
    let ratio = i / numSteps;
    thresholds.push(ratio);
  }

  thresholds.push(0);
  return thresholds;
}

function handleIntersect(entries, heroObserver) {
  entries.forEach(entry => {
    //Only do parallax on large screens, since it looks choppy on mobile
    if ($(window).width() >= 768) {
      entry.target.style.transform = `translateY(${entry.intersectionRatio *
        -100}px)`;
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/util/parallax.js